import { render } from "./TermsDPACancellation.vue?vue&type=template&id=97b79ff6"
import script from "./TermsDPACancellation.vue?vue&type=script&lang=js"
export * from "./TermsDPACancellation.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3529439572/src/mpz-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__